<template>
  <div>
    <div class="flex" :key="lesson" @contextmenu="handleRightClick">
      <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

      <div
        class="absolute top-[15%] z-[60] bg-blues p-2 lg:hidden cursor-pointer h-[40px] rounded-r-xl"
        @click="toggleMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 50 50"
          fill="#fff"
        >
          <path
            d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z"
          ></path>
        </svg>
      </div>

      <div
        class="lg:flex fixed w-[85%] bg-white lg:w-[35%] xl:w-[30%] 2xl:w-[25%] lg:relative z-[40] m-4 px-5 py-4 rounded-3xl"
        :class="{ hidden: !isMobile }"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div
          @click="toggleSidebar"
          class="absolute top-2 right-[2px] z-30 block lg:hidden bg-gray-200 rounded-full p-1 cursor-pointer"
        >
          <!-- <span class="text-2xl">⬅️</span> -->
          <img src="@/assets/leftaaa.svg" alt="" srcset="" class="w-5 h-5" />
        </div>
        <div>
          <div
            class="hidden lg:flex flex-col gap-5 relative w-full overflow-y-auto heighttab border-r border-gray-200 pr-4"
          >
            <router-link
              :to="{ name: 'StudentCourseProgress' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{
                'bg-[#0085DB]': $route.name == 'StudentCourseProgress',
              }"
            >
              <img
                src="@/assets/newd/icons/Grid.png"
                v-if="$route.name == 'StudentCourseProgress'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Grid-1.png"
                v-if="$route.name != 'StudentCourseProgress'"
                alt=""
              />
            </router-link>

            <router-link
              :to="{ name: 'StudentNewMessages' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentNewMessages' }"
            >
              <img
                src="@/assets/newd/icons/mdi-light_forum-1.png"
                v-if="$route.name == 'StudentNewMessages'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/mdi-light_forum.png"
                v-if="$route.name != 'StudentNewMessages'"
                alt=""
              />
            </router-link>

            <router-link
              :to="{ name: 'StudentAssignments' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentAssignments' }"
            >
              <img
                src="@/assets/newd/icons/gg_notes-1.png"
                v-if="$route.name == 'StudentAssignments'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/gg_notes.png"
                v-if="$route.name != 'StudentAssignments'"
                alt=""
              />
            </router-link>

            <router-link
              :to="{ name: 'StudentNewForums' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentNewForums' }"
            >
              <img
                src="@/assets/newd/icons/Archive-1.png"
                v-if="$route.name == 'StudentNewForums'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Archive.png"
                v-if="$route.name != 'StudentNewForums'"
                alt=""
              />
            </router-link>

            <router-link
              :to="{ name: 'StudentClasses' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentClasses' }"
            >
              <img
                src="@/assets/newd/icons/Calendar2Week-1.png"
                v-if="$route.name == 'StudentClasses'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Calendar2Week.png"
                v-if="$route.name != 'StudentClasses'"
                alt=""
              />
            </router-link>

            <router-link
              :to="{ name: 'StudentAssessments' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentAssessments' }"
            >
              <img
                src="@/assets/newd/icons/BarChartLine-1.png"
                v-if="$route.name == 'StudentAssessments'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/BarChartLine.png"
                v-if="$route.name != 'StudentAssessments'"
                alt=""
              />
            </router-link>

            <!-- <router-link
              :to="{ name: 'StudentReport' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentReport' }"
            >
              <img
                src="@/assets/newd/icons/CloudArrowDown-1.png"
                v-if="$route.name == 'StudentReport'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/CloudArrowDown.png"
                v-if="$route.name != 'StudentReport'"
                alt=""
              />
            </router-link> -->

            <router-link
              :to="{ name: 'StudentProject' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentProject' }"
            >
              <img
                src="@/assets/newd/icons/gg_notes-1.png"
                v-if="$route.name == 'StudentProject'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/gg_notes.png"
                v-if="$route.name != 'StudentProject'"
                alt=""
              />
            </router-link>
          </div>
        </div>

        <!-- Side Nav Menu -->
        <div
          class="flex flex-col relative w-full h-full overflow-y-auto heighttab"
          id="scroll-container"
          @scroll="saveScroll"
          ref="navMenu"
        >
          <div
            v-for="(section, sectionIndex) in sectionInfo.data"
            :key="section.id"
          >
            <div
              class="text-black flex items-center rounded-2xl px-3 py-1 justify-between cursor-pointer"
              @click="courseSectionToggle(section.id)"
            >
              <p class="font-bold text-sm py-3 text-black">
                {{ section.title }}
                <span
                  v-if="
                    section.locking_status === true &&
                    checkSectionLocked(section.id)
                  "
                  class="text-red-500 text-xs ml-2"
                >
                  🔒
                </span>
              </p>
              <img
                src="@/assets/new/up.png"
                v-if="activeCourseMenu == section.id"
                style="height: 6px !important"
                alt=""
              />
              <img
                src="@/assets/new/down.png"
                v-if="activeCourseMenu != section.id"
                style="height: 6px !important"
                alt=""
              />
            </div>
            <div
              v-if="activeCourseMenu === section.id && loadingLessons"
              class="px-4 py-3"
            >
              <div class="space-y-2">
                <div class="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
                <div class="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
                <div class="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
              </div>
            </div>
            <div
              v-if="activeCourseMenu == section.id && !loadingLessons"
              v-for="(lesson, index) in getLessonsForSection(section.id)"
              :key="lesson.id"
            >
              <div class="my-1 flex flex-col">
                <!-- Completed Lesson -->
                <!-- @click.prevent="handleLessonClick(lesson)" -->
                <router-link
                  v-if="lesson.section_participant?.status == true"
                  :to="{ name: 'LessonView', params: { lesson_id: lesson.id } }"
                  class="flex items-center rounded-2xl px-3 py-2 cursor-pointer"
                  :data-lesson-id="lesson.id"
                  :ref="`lesson-${lesson.id}`"
                >
                  <div class="w-[16px]">
                    <div class="w-[18px]">
                      <img
                        src="@/assets/mdi_tick-circle-outline.png"
                        class="object-cover w-4 h-4 font-semibold"
                      />
                    </div>
                  </div>
                  <p
                    class="text-sm py-1 pl-1"
                    :class="{
                      'text-blues font-bold actived': lesson_id == lesson.id,
                    }"
                  >
                    {{ lesson.title }}
                  </p>
                </router-link>

                <!-- Current Active Lesson -->
                <!-- @click.prevent="handleLessonClick(lesson)" -->

                <router-link
                  v-else-if="checkLessonAccessible(lesson, section.id)"
                  :to="{ name: 'LessonView', params: { lesson_id: lesson.id } }"
                  class="flex items-center rounded-2xl px-3 py-2 cursor-pointer"
                  :data-lesson-id="lesson.id"
                  :ref="`lesson-${lesson.id}`"
                >
                  <div class="w-[18px]">
                    <div class="w-[16px]">
                      <p v-if="lesson.file_type == 'video'">🎥</p>
                      <p v-if="lesson.file_type == 'download'">⬇️</p>
                      <p v-if="lesson.file_type == 'document'">📄</p>
                      <p v-if="lesson.file_type == 'pdf'">📕</p>
                      <p v-if="lesson.file_type == 'word'">📘</p>
                      <p v-if="lesson.file_type == 'general'">⚫</p>
                    </div>
                  </div>
                  <p
                    class="text-sm py-1 pl-1"
                    :class="{
                      'text-blues font-bold actived':
                        this.lesson_id == lesson.id,
                    }"
                  >
                    {{ lesson.title }}
                  </p>
                </router-link>

                <!-- Locked Lesson -->
                <div
                  v-else
                  class="flex items-center rounded-2xl px-3 py-2 cursor-not-allowed opacity-50"
                >
                  <div class="w-[18px]">
                    <div class="w-[16px]">
                      <p v-if="lesson.file_type == 'video'">🎥</p>
                      <p v-if="lesson.file_type == 'download'">⬇️</p>
                      <p v-if="lesson.file_type == 'document'">📄</p>
                      <p v-if="lesson.file_type == 'pdf'">📕</p>
                      <p v-if="lesson.file_type == 'word'">📘</p>
                      <p v-if="lesson.file_type == 'general'">⚫</p>
                    </div>
                  </div>
                  <p class="text-sm py-1 pl-1 text-gray-400">
                    {{ lesson.title }}
                    <span class="text-red-500 text-xs ml-2">🔒</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div
        class="w-[95%] lg:mr-4 mt-4 rounded-3xl h-[calc(95vh-100px)] overflow-y-scroll"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- Desktop Navigation -->
        <div class="hidden lg:block top-0">
          <div class="flex items-center pt-10 px-10 justify-between">
            <button
              @click="handleBack"
              class="bg-blues hover:bg-blue-600 text-xs text-white px-6 py-1.5 rounded-2xl"
            >
              Back
            </button>

            <h1
              class="text-lg 2xl:text-lg font-semibold w-[50%] mx-auto text-center 2xl:w-[60%] line-clamp-3"
            >
              {{ $route.params.title }}
            </h1>

            <div class="flex items-center gap-10 text-sm">
              <div
                @click="goToPreviousLesson"
                class="flex items-center gap-4 cursor-pointer"
                v-if="hasPreviousLesson && isPreviousLessonAccessible"
              >
                <img src="@/assets/new/left.png" class="h-3" />
                <p class="text-base">Previous</p>
              </div>
              <div
                @click="goToNextLesson"
                class="flex items-center gap-4 cursor-pointer"
                v-if="hasNextLesson && isNextLessonAccessible"
              >
                <p class="text-base">Next</p>
                <img src="@/assets/new/right.png" class="h-3" />
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Navigation -->
        <div
          class="flex flex-col gap-4 items-center pt-10 px-5 justify-between block lg:hidden"
        >
          <div class="flex flex-col gap-2 justify-between w-full">
            <div class="flex justify-end">
              <router-link
                :to="{ name: 'StudentCourseProgress' }"
                class="bg-blues hover:bg-blue-600 text-xs text-white px-6 py-1.5 rounded-2xl"
              >
                Back
              </router-link>
            </div>
          </div>

          <div class="flex items-center gap-10 text-sm">
            <router-link
              :to="{
                name: 'LessonView',
                params: { lesson_id: lesson.previous_id },
              }"
              class="flex items-center gap-4 cursor-pointer"
              v-if="lesson.previous_id != null && isPreviousLessonAccessible"
            >
              <img src="@/assets/new/left.png" class="h-3" />
              <p class="text-base">Previous</p>
            </router-link>
            <router-link
              :to="{
                name: 'LessonView',
                params: { lesson_id: lesson.next_id },
              }"
              class="flex items-center gap-4 cursor-pointer"
              v-if="lesson.next_id != null && isNextLessonAccessible"
            >
              <p class="text-base">Next</p>
              <img src="@/assets/new/right.png" class="h-3" />
            </router-link>
          </div>
        </div>

        <!-- Lesson Content -->

        <div
          v-if="loadingLessons"
          class="flex flex-col items-center justify-center h-[calc(95vh-100px)]"
        >
          <div
            class="animate-spin rounded-full h-10 w-10 border-b-2 border-[#01b0f9]"
          ></div>
        </div>
        <div
          class="p-5 lg:p-10 flex flex-col gap-10 -mt-5"
          v-if="lesson && !loadingLessons"
        >
          <!-- Show warning if lesson is locked -->
          <div
            v-if="isCurrentLessonLocked"
            class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4"
          >
            <div class="flex">
              <div class="ml-3">
                <p class="text-sm text-yellow-700">
                  <strong>Lesson Locked:</strong>
                  {{ lockMessage }}
                </p>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4 top-[10%]">
            <div class="flex items-center justify-between w-full">
              <h1 class="text-lg lg:text-lg font-semibold">
                {{ lesson.title }}
                <span
                  v-if="isCurrentLessonLocked"
                  class="text-red-500 text-sm ml-2"
                  >🔒</span
                >
              </h1>
              <div v-if="lesson?.quizzes[0]?.quiz?.persentage == true">
                <div
                  class="flex items-center justify-end gap-10"
                  :key="lesson"
                  v-if="
                    lesson.quizzes[0].quiz.persentage_score <=
                    lesson.user_quiz.persentage_scored
                  "
                >
                  <div
                    v-if="
                      lessonCompletedData === false ||
                      lessonCompletedData === null
                    "
                  >
                    <button
                      class="text-xs text-white px-6 py-1.5 rounded-2xl flex items-center gap-2 transition-all"
                      @click="completeUnit(lesson.section_id, lesson.id)"
                      :disabled="isCurrentLessonLocked || completeLoading"
                      :class="[
                        isCurrentLessonLocked || completeLoading
                          ? 'bg-blues hover:bg-blue-600 cursor-not-allowed'
                          : 'bg-blues hover:bg-blue-600',
                      ]"
                    >
                      <span v-if="!completeLoading"> Complete</span>

                      <span v-else class="flex items-center gap-2">
                        <svg
                          class="animate-spin h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                          />
                          <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                          />
                        </svg>
                        Completing...
                      </span>
                    </button>
                  </div>

                  <div v-else>
                    <button
                      class="bg-green-700 text-white text-xs px-4 py-2 rounded-2xl"
                    >
                      Lesson Completed
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="flex items-center justify-end gap-10" :key="lesson">
                  <div
                    v-if="
                      lessonCompletedData === false ||
                      lessonCompletedData === null
                    "
                  >
                    <button
                      class="text-xs text-white px-6 py-1.5 rounded-2xl flex items-center gap-2 transition-all"
                      @click="completeUnit(lesson.section_id, lesson.id)"
                      :disabled="isCurrentLessonLocked || completeLoading"
                      :class="[
                        isCurrentLessonLocked || completeLoading
                          ? 'bg-blues hover:bg-blue-600 cursor-not-allowed'
                          : 'bg-blues hover:bg-blue-600',
                      ]"
                    >
                      <span v-if="!completeLoading"> Complete </span>

                      <span v-else class="flex items-center gap-2">
                        <svg
                          class="animate-spin h-4 w-4 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                          />
                          <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                          />
                        </svg>
                        Completing...
                      </span>
                    </button>
                  </div>

                  <div v-else>
                    <button
                      class="bg-green-700 text-white text-xs px-4 py-2 rounded-2xl"
                    >
                      Lesson Completed
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="flex items-center gap-10 -mt-3"
              v-if="
                lesson.lesson_or_quiz !== 'quiz' && lesson.scrom_file === null
              "
            >
              <div class="flex items-center rounded-2xl py-3 gap-2">
                <img src="@/assets/new/time.png" alt="" class="h-4 w-4" />
                <p class="text-xs">{{ lesson.duration }} min</p>
              </div>
            </div>
          </div>
          <div class="overflow-y-hidden" v-if="lesson.scrom_file">
            <iframe
              :src="lesson.scrom_file"
              class="w-full h-screen border-0"
              allowfullscreen
            ></iframe>
          </div>

          <!-- Video/Content Area -->
          <div v-if="!lesson.scrom_file">
            <div
              v-if="!isCurrentLessonLocked"
              class="flex flex-col -mt-10 px-2 2xl:h-[calc(80vh-100px)] overflow-y-hidden"
            >
              <div
                v-if="lesson.video_url != null && lesson.video_url != ''"
                class="bg-gray-200 rounded-lg relative"
              >
                <iframe
                  v-if="matchYoutubeUrl(lesson.video_url)"
                  class="w-[900px] lg:h-[400px] mx-auto rounded p-3"
                  :src="lesson.video_url"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  @contextmenu.prevent
                >
                </iframe>
                <div
                  v-else-if="isPdf(lesson.video_url)"
                  class="relative w-full h-[700px] overflow-hidden rounded-lg"
                >
                  <iframe
                    :src="lesson.video_url"
                    class="absolute left-0 w-full border-0"
                    style="top: -40px; height: calc(100% + 40px)"
                  ></iframe>
                </div>

                <!-- Excel -->
                <div
                  v-else-if="isExcel(lesson.video_url)"
                  class="relative w-full h-[700px] overflow-hidden rounded-lg"
                >
                  <iframe
                    :src="officeViewerUrl(lesson.video_url)"
                    class="absolute left-0 w-full border-0"
                    style="top: -24px; height: calc(100% + 24px + 30px)"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>

                <div
                  v-else-if="isWord(lesson.video_url)"
                  class="relative w-full h-[700px] overflow-hidden rounded-lg"
                >
                  <iframe
                    :src="officeViewerUrl(lesson.video_url)"
                    class="absolute left-0 w-full border-0"
                    style="top: -24px; height: calc(100% + 24px + 30px)"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </div>

                <div
                  v-else
                  class="relative w-full max-w-[900px] mx-auto rounded-lg overflow-visible bg-black"
                >
                  <!-- Floating Settings Gear -->
                  <div
                    class="absolute top-4 right-4 z-[50]"
                    ref="settingsMenuContainer"
                  >
                    <button
                      @click="showSettingsMenu = !showSettingsMenu"
                      class="bg-black/60 text-white p-2 rounded-full hover:bg-black/80 transition-all focus:outline-none backdrop-blur-sm shadow-md"
                    >
                      <!-- Gear Icon -->
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </button>

                    <!-- Dropdown Settings Menu -->
                    <div
                      v-show="showSettingsMenu"
                      class="absolute right-0 top-12 w-48 bg-[#303030] rounded-xl shadow-2xl border border-gray-700 overflow-hidden text-white z-50"
                    >
                      <!-- Header -->
                      <div class="px-3 py-2 border-b border-gray-700">
                        <h3
                          class="text-xs font-semibold tracking-wide text-gray-200"
                        >
                          Video Settings
                        </h3>
                      </div>

                      <!-- Playback Speed -->
                      <div
                        class="flex items-center justify-between px-3 py-2 border-b border-gray-700 hover:bg-[#3a3a3a] transition"
                      >
                        <span class="text-xs text-gray-300">Speed</span>

                        <select
                          v-model="selectedSpeed"
                          @change="changeSpeed"
                          class="bg-[#404040] border border-gray-600 rounded-md text-xs text-white px-2 py-1 outline-none focus:border-[#00bcd4] cursor-pointer w-20"
                        >
                          <option
                            v-for="rate in playbackRates"
                            :key="rate"
                            :value="rate"
                          >
                            {{ rate === 1 ? "Normal" : rate + "x" }}
                          </option>
                        </select>
                      </div>

                      <!-- Video Quality -->
                      <div
                        class="flex items-center justify-between px-3 py-2 hover:bg-[#3a3a3a] transition"
                      >
                        <span class="text-xs text-gray-300">Quality</span>

                        <!-- HLS -->
                        <select
                          v-if="hlsLevels.length > 0"
                          v-model="selectedQuality"
                          @change="changeQuality"
                          class="bg-[#404040] border border-gray-600 rounded-md text-xs text-white px-2 py-1 outline-none focus:border-[#00bcd4] cursor-pointer w-20"
                        >
                          <option :value="-1">Auto</option>

                          <option
                            v-for="(level, index) in hlsLevels"
                            :key="index"
                            :value="index"
                          >
                            {{ level.height }}p
                          </option>
                        </select>

                        <!-- MP4 / WEBM -->
                        <input
                          v-else
                          type="text"
                          :value="videoResolution || 'Loading...'"
                          readonly
                          class="w-20 text-center bg-[#404040] border border-gray-600 rounded-md text-xs text-gray-200 px-2 py-1"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Video Element -->
                  <video
                    ref="videoPlayer"
                    class="w-full max-h-[300px] overflow-y-auto xl:max-h-[250px] 2xl:max-h-[400px] rounded-lg p-3"
                    controls
                    autoplay
                    playsinline
                    controlsList="nodownload"
                    disablePictureInPicture
                    @ended="addPolls(lesson)"
                    @loadedmetadata="onMetadataLoaded"
                    @contextmenu.prevent
                    @dragstart.prevent
                    @play="onVideoActivity"
                    @timeupdate="onVideoActivity"
                    @pause="onVideoActivity"
                  ></video>
                </div>
                <!-- Poll Display -->
                <div
                  v-if="lesson.show_polls"
                  class="flex flex-col gap-3 px-10 pb-5"
                >
                  <p class="text-xs font-bold">Poll answers:</p>
                  <div
                    class="flex items-center gap-3"
                    v-if="lesson.poll_details != null"
                  >
                    <p
                      v-for="option in lesson.poll_details.options"
                      :key="option"
                      class="bg-blues px-3 py-1 rounded-xl text-xs text-gray-300"
                    >
                      <span class="font-bold text-white"
                        >({{ option.count }} users)</span
                      >
                      {{ option.text }}
                    </p>
                  </div>
                </div>

                <!-- Poll Modal -->
                <div
                  v-if="isPoll"
                  class="absolute w-full h-full top-0 right-0 bottom-0 left-0 flex items-center justify-center bg-black bg-opacity-50"
                >
                  <div
                    v-if="poll_status"
                    class="bg-white w-[50%] rounded-xl px-6 py-5 flex flex-col justify-center items-center gap-4 relative"
                  >
                    <p
                      class="bg-red-500 rounded-full text-xs w-5 h-5 flex items-center justify-center text-white absolute -right-2 -top-2 cursor-pointer"
                      @click="isPoll = false"
                    >
                      x
                    </p>
                    <h1 class="text-center text-black text-xl font-semibold">
                      Thankyou !
                    </h1>
                    <p
                      :class="[
                        this.messages.type == 'success'
                          ? 'text-green-400'
                          : 'text-red-400',
                      ]"
                      class="capitalize text-md text-center"
                    >
                      {{ this.messages.text }}
                    </p>
                  </div>
                  <form
                    v-else
                    @submit.prevent="pollSubmit"
                    class="bg-white w-[50%] rounded-xl px-6 py-5 flex flex-col gap-4 relative"
                  >
                    <p
                      class="bg-red-500 rounded-full text-xs w-5 h-5 flex items-center justify-center text-white absolute -right-2 -top-2 cursor-pointer"
                      @click="isPoll = false"
                    >
                      x
                    </p>
                    <div class="flex flex-col gap-3">
                      <div class="text-black font-semibold">
                        {{ this.poll_question.question }}
                      </div>
                      <div
                        v-for="poll in this.poll_question.options"
                        :key="poll.id"
                        class="flex flex-col gap-3"
                      >
                        <div class="flex gap-2 items-center">
                          <input
                            type="radio"
                            :value="poll.id"
                            v-model="selected_poll_option"
                            :id="'poll_' + poll.id"
                            name="pollOption"
                            class="cursor-pointer p-1"
                          />
                          <label :for="'poll_' + poll.id">{{
                            poll.text
                          }}</label>
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex flex-col gap-2"
                      v-if="selected_poll_option != null"
                    >
                      <label for="remark">Remark</label>
                      <input
                        type="text"
                        v-model="remarks"
                        name="remarks"
                        class="cursor-pointer p-1 border rounded-lg"
                      />
                    </div>
                    <div>
                      <button
                        type="submit"
                        class="bg-blues text-white px-3 py-1 rounded-lg text-xs"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>

                <!-- Autoplay Countdown Popup -->
                <div
                  v-if="showPopup"
                  class="z-[1000] flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
                >
                  <div
                    class="!z-999 relative flex justify-center items-center bg-white p-5 lg:p-8 w-[90%] lg:w-[380px] rounded-lg"
                  >
                    <div class="w-full flex flex-col gap-3">
                      <p class="mb-2 text-sm">
                        Next video will autoplay in {{ countdown }} seconds.
                      </p>
                      <div class="w-full flex items-center justify-center">
                        <button
                          @click="cancelAutoplay"
                          class="bg-blues text-white px-4 py-2 rounded-lg"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Additional Content -->
              <div class="flex flex-col gap-4">
                <div
                  v-html="lesson.content"
                  class="w-full video-container"
                ></div>

                <iframe
                  v-if="lesson.pdf_file != null && lesson.pdf_file != ''"
                  :src="convertHttpToHttps(lesson.pdf_file)"
                  class="lg:h-[400px]"
                ></iframe>

                <p class="text-sm" v-if="lesson.keyworeds">
                  <span class="font-semibold">Keywords:</span>
                  {{ lesson.keyworeds }}
                </p>

                <audio
                  controls
                  v-if="lesson.audio_file != null && lesson.audio_file != ''"
                >
                  <source :src="lesson.audio_file" type="audio/ogg" />
                  <source :src="lesson.audio_file" type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>

                <!-- Quiz Section -->
                <div v-if="lesson.lesson_or_quiz === 'quiz'" class="mt-10">
                  <div
                    v-if="
                      lesson.quizzes &&
                      lesson.quizzes[0] &&
                      lesson.quizzes[0].quiz
                    "
                  >
                    <p
                      class="text-base font-bold"
                      v-if="lesson.quizzes[0].quiz.question_attempt"
                    >
                      Quiz Attempt Count: {{ lesson.user_quize_count }} /
                      {{ lesson.quizzes[0].quiz.question_attempt_count }}
                    </p>

                    <div
                      v-if="
                        lesson.quizzes[0].quiz.question_attempt &&
                        lesson.user_quize_count ===
                          lesson.quizzes[0].quiz.question_attempt_count
                      "
                      class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                    >
                      <p class="text-lg font-semibold text-center">
                        You have completed all attempts of this Quiz.
                      </p>

                      <router-link
                        :to="{
                          name: 'StudentAssessments',
                          query: {
                            tab: 'lesson',
                            quiz_id: lesson.quizzes[0].quiz.id,
                          },
                        }"
                        class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB]"
                      >
                        <p class="font-bold text-xs text-white">
                          View Score Board
                        </p>
                      </router-link>
                    </div>

                    <div
                      v-else-if="lessonCompletedData"
                      class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                    >
                      <p class="text-lg font-semibold text-center">
                        Lesson completed — You cannot attend the quiz.
                      </p>

                      <router-link
                        :to="{
                          name: 'StudentAssessments',
                          query: {
                            tab: 'lesson',
                            quiz_id: lesson.quizzes[0].quiz.id,
                          },
                        }"
                        class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB]"
                      >
                        <p class="font-bold text-xs text-white">
                          View Score Board
                        </p>
                      </router-link>
                    </div>

                    <div
                      v-else-if="lesson.course_quiz_takers_id != null"
                      class="flex flex-col items-center justify-center gap-4 py-6 px-10 border rounded-xl"
                    >
                      <p class="text-lg font-semibold text-center">
                        You have completed the Quiz.
                      </p>

                      <router-link
                        :to="{
                          name: 'StudentAssessments',
                          query: {
                            tab: 'lesson',
                            quiz_id: lesson.quizzes[0].quiz.id,
                          },
                        }"
                        class="flex items-center gap-5 px-4 py-2 rounded-xl bg-[#0085DB] hover:bg-blue-600"
                      >
                        <p class="font-bold text-xs text-white">
                          View Score Board
                        </p>
                      </router-link>
                    </div>

                    <div v-else>
                      <QuizTest
                        ref="quizRef"
                        :key="quizKey"
                        :course_id="course_id"
                        :quiz_id="lesson.quizzes[0].quiz.id"
                        :taker_id="lesson.course_quiz_takers_id"
                        :feedback="lesson.quizzes[0].quiz.quizsfeedback"
                        @pushLessonComplete="receiveLessonComplete"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Locked Content Message -->
            <div
              v-else
              class="flex flex-col items-center justify-center h-64 bg-gray-50 rounded-lg"
            >
              <div class="text-center">
                <div class="text-6xl mb-4">🔒</div>
                <h3 class="text-xl font-semibold text-gray-700 mb-2">
                  Lesson Locked
                </h3>
                <p class="text-gray-600 mb-4">
                  {{ lockedContentMessage }}
                </p>
                <router-link
                  v-if="isSectionLocked && getFirstIncompleteLesson"
                  :to="{
                    name: 'LessonView',
                    params: { lesson_id: getFirstIncompleteLesson.id },
                  }"
                  class="bg-blues text-white px-6 py-2 rounded-lg"
                >
                  Go to First Available Lesson
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- feedabck -->
    <div
      v-if="feedbackModal.open"
      class="fixed inset-0 z-[1000] flex justify-center items-center bg-black bg-opacity-50"
    >
      <div class="bg-white p-8 rounded-2xl w-full max-w-xl">
        <h3 class="text-2xl font-bold text-center text-blues mb-6">
          Submit {{ feedbackModal.type }} Feedback
        </h3>

        <textarea
          v-model="feedbackText"
          rows="4"
          minlength="10"
          required
          class="w-full border rounded-lg p-3 mb-4"
        ></textarea>

        <div class="flex gap-1 mb-6">
          <svg
            v-for="i in 5"
            :key="i"
            @click="selectedRating = i"
            :class="i <= selectedRating ? 'text-yellow-400' : 'text-gray-300'"
            class="w-6 h-6 cursor-pointer"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
            />
          </svg>
        </div>

        <div class="flex justify-between">
          <button @click="skipFeedback" class="bg-gray-300 px-4 py-2 rounded">
            Skip
          </button>

          <button
            @click="submitFeedback"
            :disabled="disable_submit"
            class="bg-blues text-white px-6 py-2 rounded"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState, mapMutations } from "vuex";
import QuizTest from "@/views/Student/Dashboard/QuizTestComp.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import rightClickProtection from "@/mixins/rightClickProtection";
import { videoActivity } from "@/composables/useAutoLogout";
import Hls from "hls.js";
export default {
  mixins: [rightClickProtection],
  name: "Lesson",
  props: ["lesson_id", "course_id"],
  components: {
    QuizTest,
    FlashMessage,
  },

  data() {
    return {
      lesson: "",
      lessonCompletedData: null,
      sectionInfo: "",
      lessonInfo: "",
      activeCourseMenu: null,
      showbutton: false,
      messages: {
        text: "",
        type: "null",
      },
      showPopup: false,
      countdown: 10,
      countdownInterval: null,
      isPoll: false,
      poll_question: null,
      selected_poll_question: null,
      selected_poll_option: null,
      player: null,
      poll_status: false,
      remarks: "",
      isMobile: false,
      hide_menu: true,
      scrollQueue: [],
      hlsLevels: [],
      selectedQuality: -1,
      videoResolution: "",
      hlsInstance: null,
      isNativeVideo: false,
      playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2],
      selectedSpeed: 1,
      showSettingsMenu: false,
      isScrolling: false,
      navigationTimeout: null,
      quizKey: 0,
      iframeInterval: null,

      feedbackModal: {
        open: false,
        type: null,
        targetId: null,
      },

      feedbackText: "",
      selectedRating: 0,
      disable_submit: false,

      navigationDirection: null,
      pendingLesson: null,
      loadingLessons: true,
      lockedSections: [],
      completeLoading: false,
    };
  },

  watch: {
    async "$route.params.lesson_id"(newId, oldId) {
      if (newId !== oldId) {
        if (this.$refs.quizRef) {
          this.$refs.quizRef.autoSubmitFromOutside();
        }

        this.quizKey++;
        await this.getLesson();
        await this.getCompletedLesson();
        await this.detailsgets();

        this.$nextTick(() => {
          this.scrollToActiveLessonById(newId);
        });
      }
    },
    loadingLessons(newVal) {
      if (!newVal && this.lesson && this.lesson.video_url) {
        this.$nextTick(() => {
          this.initPlayer();
        });
      }
    },
    "lesson.video_url"() {
      if (!this.loadingLessons && this.lesson && this.lesson.video_url) {
        this.$nextTick(() => {
          this.initPlayer();
        });
      }
    },
    lessonInfo: {
      deep: true,
      handler() {
        if (
          this.allSectionsCompleted() &&
          this.lesson.feedback_course === true &&
          this.lesson.course_feedback === false
        ) {
          this.openFeedback("course", this.course_id);
        }
      },
    },
  },

  computed: {
    ...mapGetters(["userInfo"]),
    ...mapState(["navScrollPosition"]),

    allLessonsOrdered() {
      if (!this.sectionInfo?.data || !this.lessonInfo?.results) return [];

      const sortedSections = [...this.sectionInfo.data].sort(
        (a, b) => a.orderby - b.orderby,
      );

      let ordered = [];

      for (const section of sortedSections) {
        const lessons = this.lessonInfo.results
          .filter((l) => l.section_id === section.id)
          .sort((a, b) => a.orderby - b.orderby);

        ordered.push(...lessons);
      }

      return ordered;
    },

    currentSectionIndex() {
      if (!this.sectionInfo?.data) return -1;
      const sections = [...this.sectionInfo.data].sort(
        (a, b) => a.orderby - b.orderby,
      );
      return sections.findIndex((s) => s.id === this.lesson?.section_id);
    },

    isSectionLocked() {
      if (!this.lesson) return false;
      return this.checkSectionLocked(this.lesson.section_id);
    },

    isDateLocked() {
      if (!this.lesson?.locking_status) return false;
      if (!this.lesson?.locking_date) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const lockDate = new Date(this.lesson.locking_date);
      lockDate.setHours(0, 0, 0, 0);

      return lockDate > today;
    },

    isCurrentLessonLocked() {
      return this.isSectionLocked || this.isDateLocked;
    },

    lockMessage() {
      if (this.isSectionLocked) {
        return "Please complete the previous sections first.";
      }

      if (this.isDateLocked) {
        return `This lesson will unlock on ${this.formatDate(
          this.lesson.locking_date,
        )}`;
      }

      return "";
    },
    lockedContentMessage() {
      if (this.isSectionLocked) {
        return "Complete all lessons in the previous section to unlock this content.";
      }

      if (this.isDateLocked) {
        return `This lesson will unlock on ${this.formatDate(
          this.lesson.locking_date,
        )}.`;
      }

      return "";
    },

    isPreviousLessonAccessible() {
      if (!this.lesson) return false;

      const lessons = this.allLessonsOrdered;
      const currentIndex = lessons.findIndex(
        (l) => l.id === Number(this.lesson.id),
      );

      if (currentIndex > 0) {
        const previousLesson = lessons[currentIndex - 1];
        return this.checkLessonAccessible(
          previousLesson,
          previousLesson.section_id,
        );
      }

      return false;
    },

    isNextLessonAccessible() {
      if (!this.lesson || !this.hasNextLesson) return false;

      const lessons = this.allLessonsOrdered;
      const currentIndex = lessons.findIndex(
        (l) => l.id === Number(this.lesson.id),
      );

      if (currentIndex < lessons.length - 1) {
        const nextLesson = lessons[currentIndex + 1];
        return this.checkLessonAccessible(nextLesson, nextLesson.section_id);
      }

      return false;
    },

    hasNextLesson() {
      const lessons = this.allLessonsOrdered;
      const index = lessons.findIndex((l) => l.id === Number(this.lesson.id));
      return index < lessons.length - 1;
    },

    hasPreviousLesson() {
      const lessons = this.allLessonsOrdered;
      const index = lessons.findIndex((l) => l.id === Number(this.lesson.id));
      return index > 0;
    },

    getFirstIncompleteLesson() {
      if (!this.sectionInfo?.data || !this.lessonInfo?.results) return null;

      for (const section of [...this.sectionInfo.data].sort(
        (a, b) => a.orderby - b.orderby,
      )) {
        const lessons = this.lessonInfo.results
          .filter((l) => l.section_id === section.id)
          .sort((a, b) => a.orderby - b.orderby);

        for (const lesson of lessons) {
          if (
            !lesson.section_participant?.status &&
            this.checkLessonAccessible(lesson, section.id)
          ) {
            return lesson;
          }
        }
      }
      return null;
    },
  },

  created() {
    this.getLesson();
    this.getCompletedLesson();
    this.detailsgets();
  },
  mounted() {
    this.iframeInterval = setInterval(() => {
      videoActivity();
    }, 10000);
    window.addEventListener("popstate", this.handleBrowserNavigation);
    document.addEventListener("click", this.handleClickOutside);
    this.$nextTick(() => {
      if (this.lesson_id && this.lessonInfo.results) {
        this.scrollToActiveLessonById(this.lesson_id);
      }
    });

    const video = this.$refs.videoPlayer;
    if (video) {
      video.play().catch((err) => {
        console.error("Autoplay failed:", err);
      });
    }

    if (this.lesson.section_participant) {
      if (this.lesson.section_participant.status == null) {
        this.completeUnitStart();
      }
    }
  },

  beforeUnmount() {
    clearInterval(this.iframeInterval);
    window.removeEventListener("popstate", this.handleBrowserNavigation);
    document.removeEventListener("click", this.handleClickOutside);
    if (this.navigationTimeout) {
      clearTimeout(this.navigationTimeout);
    }
    this.scrollQueue = [];
    if (this.hlsInstance) {
      this.hlsInstance.destroy();
      this.hlsInstance = null;
    }
  },

  methods: {
    handleClickOutside(event) {
      const container = this.$refs.settingsMenuContainer;
      if (container && !container.contains(event.target)) {
        this.showSettingsMenu = false;
      }
    },

    initPlayer() {
      const video = this.$refs.videoPlayer;

      if (
        !video ||
        !this.lesson ||
        !this.lesson.video_url ||
        this.matchYoutubeUrl(this.lesson.video_url) ||
        this.isPdf(this.lesson.video_url) ||
        this.isExcel(this.lesson.video_url) ||
        this.isWord(this.lesson.video_url)
      ) {
        return;
      }

      // Destroy previous HLS player
      if (this.hlsInstance) {
        this.hlsInstance.destroy();
        this.hlsInstance = null;
      }

      this.hlsLevels = [];
      this.selectedQuality = -1;

      const url = this.lesson.video_url;

      // ---------- HLS ----------
      if (url.endsWith(".m3u8")) {
        if (Hls.isSupported()) {
          this.hlsInstance = new Hls({
            capLevelToPlayerSize: true,
          });

          this.hlsInstance.loadSource(url);
          this.hlsInstance.attachMedia(video);

          this.hlsInstance.on(Hls.Events.MANIFEST_PARSED, (_, data) => {
            console.log("Levels", data.levels);
            this.hlsLevels = data.levels;

            console.log("Available Qualities:", this.hlsLevels);

            video.playbackRate = Number(this.selectedSpeed);

            video.play().catch(() => {});
          });

          this.hlsInstance.on(Hls.Events.LEVEL_SWITCHED, (_, data) => {
            if (!this.hlsInstance.autoLevelEnabled) {
              this.selectedQuality = data.level;
            }
          });
        }

        // Safari
        else if (video.canPlayType("application/vnd.apple.mpegurl")) {
          video.src = url;
          video.load();
          video.play();
        }
      }

      // ---------- MP4 / WEBM ----------
      else {
        video.src = url;
        video.load();

        this.hlsLevels = [];

        video.playbackRate = Number(this.selectedSpeed);

        video.play().catch(() => {});
      }
    },

    changeQuality() {
      if (!this.hlsInstance) return;

      if (Number(this.selectedQuality) === -1) {
        this.hlsInstance.currentLevel = -1;
      } else {
        this.hlsInstance.currentLevel = Number(this.selectedQuality);
      }
    },

    changeSpeed() {
      const video = this.$refs.videoPlayer;

      if (!video) return;

      video.playbackRate = Number(this.selectedSpeed);
    },
    isPdf(url) {
      return /\.pdf$/i.test(url);
    },

    isExcel(url) {
      return /\.(xlsx|xls)$/i.test(url);
    },

    isWord(url) {
      return /\.(doc|docx)$/i.test(url);
    },

    officeViewerUrl(url) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        url,
      )}`;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    onVideoActivity() {
      videoActivity();
    },
    getLessonsForSection(sectionId) {
      if (!this.lessonInfo?.results) return [];
      return this.lessonInfo.results
        .filter((l) => l.section_id === sectionId)
        .sort((a, b) => a.orderby - b.orderby);
    },

    isSectionCompleted(sectionId) {
      const lessons = this.getLessonsForSection(sectionId);
      if (lessons.length === 0) return false;

      return lessons.every(
        (lesson) => lesson.section_participant?.status === true,
      );
    },

    checkSectionLocked(sectionId) {
      if (!this.sectionInfo?.data || !this.sectionInfo.data.length) return true;
      // if (this.lockedSections?.includes(sectionId)) {
      //   return true;
      // }
      // Find the target section
      const targetSection = this.sectionInfo.data.find(
        (s) => s.id === sectionId,
      );

      // If section locking_status is false, section is NOT locked
      if (targetSection && targetSection.locking_status === false) {
        return false;
      }
      const sortedSections = [...this.sectionInfo.data].sort(
        (a, b) => a.orderby - b.orderby,
      );
      const targetSectionIndex = sortedSections.findIndex(
        (s) => s.id === sectionId,
      );

      if (targetSectionIndex === -1) return true;
      if (targetSectionIndex === 0) return false;

      const previousSection = sortedSections[targetSectionIndex - 1];
      if (!previousSection) return false;

      return !this.isSectionCompleted(previousSection.id);
    },

    checkLessonAccessible(lesson, sectionId) {
      if (lesson.section_participant?.status === true) return true;
      // Find the section
      const section = this.sectionInfo?.data?.find((s) => s.id === sectionId);

      // If section locking_status is false, ALL lessons in this section are accessible
      if (section && section.locking_status === false) {
        return true;
      }

      if (this.checkSectionLocked(sectionId)) return false;

      const lessonsInSection = this.getLessonsForSection(sectionId);
      const lessonIndex = lessonsInSection.findIndex((l) => l.id === lesson.id);

      if (lessonIndex === 0) return true;

      for (let i = 0; i < lessonIndex; i++) {
        if (!lessonsInSection[i].section_participant?.status) {
          return false;
        }
      }

      return true;
    },

    async handleBack() {
      try {
        if (
          this.lesson.lesson_or_quiz === "quiz" &&
          this.$refs.quizRef &&
          typeof this.$refs.quizRef.ckans === "function"
        ) {
          await this.$refs.quizRef.ckans();
        }
        this.$router.push({ name: "StudentCourseProgress" });
      } catch (error) {
        console.error("Error during quiz submit:", error);
      }
    },

    callQuizFunction() {
      return new Promise((resolve) => {
        if (this.$refs.quizRef) {
          this.$refs.quizRef.ckans();
        }
        resolve();
      });
    },

    handleBrowserNavigation() {
      if (this.$refs.quizRef) {
        this.$refs.quizRef.autoSubmitFromOutside();
      }
    },
    ...mapMutations(["setNavScrollPosition"]),

    saveScroll() {
      if (this.$refs.navMenu) {
        this.setNavScrollPosition(this.$refs.navMenu.scrollTop);
      }
    },

    navigateToLesson(lessonId) {
      this.saveScroll();

      this.$router.push({
        name: "LessonView",
        params: { lesson_id: lessonId },
      });
    },

    courseSectionToggle(sectionId) {
      this.activeCourseMenu =
        this.activeCourseMenu === sectionId ? null : sectionId;
    },

    goToNextLesson() {
      this.navigationDirection = "next";

      if (!this.checkFeedbackBeforeNavigation()) return;

      const lessons = this.allLessonsOrdered;
      const index = lessons.findIndex((l) => l.id === Number(this.lesson.id));
      const nextLesson = lessons[index + 1];

      if (
        nextLesson &&
        this.checkLessonAccessible(nextLesson, nextLesson.section_id)
      ) {
        this.executeNavigation(nextLesson);
      }
    },

    goToPreviousLesson() {
      this.navigationDirection = "prev";

      if (!this.checkFeedbackBeforeNavigation()) return;

      const lessons = this.allLessonsOrdered;
      const index = lessons.findIndex((l) => l.id === Number(this.lesson.id));
      const prevLesson = lessons[index - 1];

      if (
        prevLesson &&
        this.checkLessonAccessible(prevLesson, prevLesson.section_id)
      ) {
        this.executeNavigation(prevLesson);
      }
    },

    executeNavigation(targetLesson) {
      this.feedbackModal.open = false;
      this.activeCourseMenu = targetLesson.section_id;

      this.$router.push({
        name: "LessonView",
        params: { lesson_id: targetLesson.id },
      });
    },

    handleLessonClick(lesson) {
      this.navigationDirection = "direct";
      this.pendingLesson = lesson;

      // Check if lesson is accessible
      if (!this.checkLessonAccessible(lesson, lesson.section_id)) {
        this.messages = {
          text: "This lesson is locked. Please complete previous lessons first.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
        return;
      }

      if (!this.checkFeedbackBeforeNavigation()) return;

      this.executeNavigation(lesson);
    },

    restoreScrollPosition() {
      this.$nextTick(() => {
        if (this.lesson_id) {
          this.scrollToActiveLessonById(this.lesson_id);
        }
      });
    },

    ensureSectionExpandedAndScroll(lessonId) {
      if (
        !this.lessonInfo ||
        !this.lessonInfo.results ||
        this.lessonInfo.results.length === 0
      ) {
        return;
      }

      const targetLesson = this.lessonInfo.results.find(
        (l) => l.id === parseInt(lessonId),
      );

      if (!targetLesson || !targetLesson.section_id) {
        return;
      }

      if (this.activeCourseMenu !== targetLesson.section_id) {
        this.activeCourseMenu = targetLesson.section_id;
        this.$nextTick(() => {
          this.scrollToActiveLessonById(lessonId);
        });
      } else {
        this.scrollToActiveLessonById(lessonId);
      }
    },

    scrollToActiveLessonById(lessonId) {
      requestAnimationFrame(() => {
        const activeElement = document.querySelector(
          `[data-lesson-id="${lessonId}"]`,
        );
        const navMenu = this.$refs.navMenu;

        if (activeElement && navMenu) {
          const elementTop = activeElement.offsetTop;
          const elementHeight = activeElement.offsetHeight;
          const containerHeight = navMenu.clientHeight;

          const desiredScrollTop =
            elementTop - containerHeight / 2 + elementHeight / 2;

          navMenu.scrollTo({
            top: Math.max(0, desiredScrollTop),
            behavior: "smooth",
          });

          requestAnimationFrame(() => {
            this.saveScroll();
          });
        }
      });
    },

    toggleSidebar() {
      this.isMobile = false;
      this.hide_menu = true;
    },

    toggleMenu() {
      this.isMobile = !this.isMobile;
      this.hide_menu = !this.isMobile;
    },

    pollSubmit() {
      const poll_data = {
        poll: this.selected_poll_question,
        option: this.selected_poll_option,
        student: this.userInfo.user.id,
        remarks: this.remarks,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/poll/answer/?Key=${this.userInfo.token_key}`,
          poll_data,
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.getLesson();
            this.messages = {
              text: resp.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.isPoll = false;
              // this.startCountdown();
            }, 2000);
          } else if (resp.data.status == 400) {
            this.messages = {
              text: "Poll Already Submitted",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.isPoll = false;
            }, 2000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    matchYoutubeUrl(url) {
      var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (url.match(p)) {
        return true;
      }
      return false;
    },

    addPollsinTime() {
      const currentTime = this.$refs.videoPlayer.currentTime;
      console.log("check", currentTime);
    },

    addPolls(poll) {
      if (poll.polls) {
        if (!this.lesson.user_poll) {
          this.isPoll = true;
          this.poll_question = poll.poll_details;
          this.selected_poll_question = poll.poll_details.id;
        }
        // else {
        //   this.startCountdown();
        // }
      }
      //  else {
      //   this.startCountdown();
      // }
    },

    onMetadataLoaded() {
      const video = this.$refs.videoPlayer;

      this.videoWidth = video.videoWidth;
      this.videoHeight = video.videoHeight;

      if (this.videoHeight >= 2160) {
        this.videoResolution = "2160p";
      } else if (this.videoHeight >= 1440) {
        this.videoResolution = "1440p";
      } else if (this.videoHeight >= 1080) {
        this.videoResolution = "1080p";
      } else if (this.videoHeight >= 720) {
        this.videoResolution = "720p";
      } else if (this.videoHeight >= 480) {
        this.videoResolution = "480p";
      } else if (this.videoHeight >= 360) {
        this.videoResolution = "360p";
      } else {
        this.videoResolution = this.videoHeight + "p";
      }

      console.log("Width :", this.videoWidth);
      console.log("Height:", this.videoHeight);
      console.log("Quality:", this.videoResolution);
    },

    async detailsgets() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&is_publish=True&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          this.sectionInfo = response.data;
        });

      try {
        const lessonRes = await axios.get(
          `${process.env.VUE_APP_API}/lessons/?Key=${this.userInfo.token_key}&course_name=${this.course_id}`,
        );
        this.lessonInfo = lessonRes.data;
      } catch (e) {
        console.error("Lesson loading error", e);
      } finally {
        this.loadingLessons = false;
      }
    },

    getLesson() {
      return axios
        .get(
          `${process.env.VUE_APP_API}/lessons/?Key=${this.userInfo.token_key}&id=${this.lesson_id}`,
        )
        .then((response) => {
          if (response) {
            this.lesson = response.data.results[0];
            this.activeCourseMenu = response.data.results[0].section_id;
            return response.data.results[0];
          } else {
            console.log("got error");
          }
        });
    },

    convertHttpToHttps(url) {
      if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
      }
      return url;
    },

    async getCompletedLesson() {
      this.lessonCompletedData = null;
      await axios
        .get(
          `${process.env.VUE_APP_API}/completed-lesson-tracking/${this.userInfo.user.id}/${this.lesson_id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.lessonCompletedData = "";
          } else {
            console.log("Something went wrong::");
          }
        });
    },

    receiveLessonComplete() {
      // this.completeUnit();
      this.getLesson();
    },

    async quizPreview(id) {
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`,
        )
        .then((response) => {
          this.dataval = response.data.data;
        });
    },

    async completeUnitStart() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking-create/${this.userInfo.user.id}/${this.lesson.section_id}/${this.lesson_id}/?Key=${this.userInfo.token_key}`,
          {},
        )
        .then((response) => {
          if (response) {
            this.getCompletedLesson();
            this.detailsgets();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async completeUnit(section_id, lessonid) {
      // Check if lesson is locked before allowing completion
      if (this.isCurrentLessonLocked) {
        this.messages = {
          text: "Cannot complete locked lesson. Please complete previous lessons first.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
        return;
      }
      this.completeLoading = true;
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking/${this.userInfo.user.id}/${section_id}/${lessonid}/?Key=${this.userInfo.token_key}`,
          {},
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            this.lessonCompletedData = true;
            const lesson = this.lessonInfo.results.find(
              (l) => l.id === lessonid,
            );
            if (lesson) {
              lesson.section_participant.status = true;
            }

            // Refresh data to update lock status
            this.detailsgets();

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.completeLoading = false;
        });
    },

    onVideoEnded() {
      this.startCountdown();
    },

    startCountdown() {
      this.showPopup = true;
      this.countdown = 10;

      this.countdownInterval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          this.loadNextVideo();
        }
      }, 1000);
    },

    cancelAutoplay() {
      clearInterval(this.countdownInterval);
      this.showPopup = false;
    },

    loadNextVideo() {
      clearInterval(this.countdownInterval);
      this.showPopup = false;

      const nextId = this.lesson.next_id;
      if (nextId) {
        this.$router.push({
          name: "LessonView",
          params: { lesson_id: nextId },
        });
      } else {
        alert("No more videos.");
      }
    },
    setRating(rating) {
      this.selectedRating = rating;
    },
    skipFeedback() {
      this.feedbackModal.open = false;
      this.navigateAfterFeedback();
      this.feedbackText = "";
      this.selectedRating = 0;
    },

    navigateAfterFeedback() {
      const lessons = this.allLessonsOrdered;
      const index = lessons.findIndex((l) => l.id === Number(this.lesson.id));

      let target = null;

      if (this.navigationDirection === "next") {
        target = lessons[index + 1];
      } else if (this.navigationDirection === "prev") {
        target = lessons[index - 1];
      } else if (this.navigationDirection === "direct") {
        target = this.pendingLesson;
      }

      if (target && this.checkLessonAccessible(target, target.section_id)) {
        this.executeNavigation(target);
      }
    },

    async submitFeedback() {
      this.disable_submit = true;

      let url = "";
      let payload = {
        rating: this.selectedRating,
        user_id: this.userInfo.user.id,
      };

      if (this.feedbackModal.type === "lesson") {
        url = "/lesson-feedback/create/";
        payload.text = this.feedbackText;
        payload.lesson = this.feedbackModal.targetId;
      }

      if (this.feedbackModal.type === "section") {
        url = "/unit-feedback/create/";
        payload.text = this.feedbackText;
        payload.unit = this.feedbackModal.targetId;
      }

      if (this.feedbackModal.type === "course") {
        url = `/course-feedback-create/${this.feedbackModal.targetId}/`;
        payload.feedback = this.feedbackText;
        payload.course_id = this.feedbackModal.targetId;
      }

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}${url}?Key=${this.userInfo.token_key}`,
          payload,
        );

        if (response.data.status == 200) {
          this.messages = {
            text: response.data.message,
            type: "success",
          };

          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
            this.feedbackModal.open = false;
            this.feedbackText = "";
            this.selectedRating = 0;
            this.navigateAfterFeedback();
          }, 1500);
        } else {
          this.messages = {
            text: response.data.error,
            type: "error",
          };
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "null",
            };
            this.disable_submit = false;
          }, 2000);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.disable_submit = false;
      }
    },
    getSectionById(sectionId) {
      return this.sectionInfo.data.find((section) => section.id === sectionId);
    },
    isLastLessonOfSection(lesson) {
      const lessons = this.getLessonsForSection(lesson.section_id);
      if (!lessons.length) return false;
      return lessons[lessons.length - 1].id === lesson.id;
    },

    checkFeedbackBeforeNavigation() {
      const lesson = this.lesson;
      let targetLesson = null;

      if (this.navigationDirection === "direct") {
        targetLesson = this.pendingLesson;
      } else if (this.navigationDirection === "next") {
        const lessons = this.allLessonsOrdered;
        const index = lessons.findIndex((l) => l.id === Number(lesson.id));
        targetLesson = lessons[index + 1];
      } else if (this.navigationDirection === "prev") {
        const lessons = this.allLessonsOrdered;
        const index = lessons.findIndex((l) => l.id === Number(lesson.id));
        targetLesson = lessons[index - 1];
      }

      // Check if target lesson is accessible
      if (
        targetLesson &&
        !this.checkLessonAccessible(targetLesson, targetLesson.section_id)
      ) {
        this.messages = {
          text: "Cannot navigate to locked lesson. Please complete previous lessons first.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
        return false;
      }

      /* ---------- 1️⃣ LESSON FEEDBACK ---------- */
      if (
        lesson.lesson_or_quiz === "lesson" &&
        lesson.feedback === true &&
        lesson.user_feedback === false
      ) {
        this.pendingLesson = targetLesson;
        this.openFeedback("lesson", lesson.id);
        return false;
      }

      /* ---------- 2️⃣ SECTION FEEDBACK ---------- */
      const section = this.getSectionById(lesson.section_id);

      const isLeavingSection =
        targetLesson && targetLesson.section_id !== lesson.section_id;

      const isEndOfSection =
        this.isLastLessonOfSection(lesson) &&
        this.navigationDirection === "next";

      if (
        section &&
        section.feedback === true &&
        section.user_feedback === false &&
        (isLeavingSection || isEndOfSection)
      ) {
        this.openFeedback("section", section.id);
        return false;
      }

      /* ---------- 3️⃣ COURSE FEEDBACK ---------- */
      if (
        lesson.feedback_course === true &&
        lesson.course_feedback === false &&
        this.allSectionsCompleted()
      ) {
        this.openFeedback("course", this.course_id);
        return false;
      }

      return true;
    },
    allSectionsCompleted() {
      if (!this.lessonInfo?.results) return false;
      return this.lessonInfo.results.every(
        (lesson) => lesson.section_participant?.status === true,
      );
    },

    openFeedback(type, id) {
      this.feedbackModal = {
        open: true,
        type,
        targetId: id,
      };
    },
  },
};
</script>

<style scoped>
td,
thead,
tr,
th {
  text-align: center;
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heighttab {
  height: calc(108vh - 250px) !important;
}

#scroll-container {
  scroll-behavior: smooth;
}

.heightfix {
  height: calc(110vh - 250px) !important;
}

.heightfixed {
  height: calc(100vh - 450px) !important;
}

:deep(.video-container iframe) {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  max-height: 500px;
}

::-webkit-scrollbar {
  display: none;
}
</style>
